enum InstanceType {
  T3A_MEDIUM = "t3a.medium",
  M6A_LARGE = "m6a.large",
  M6A_XLARGE = "m6a.xlarge",
  M6A_2XLARGE = "m6a.2xlarge",
  M6A_4XLARGE = "m6a.4xlarge",
  M6A_8XLARGE = "m6a.8xlarge",
  M6A_12XLARGE = "m6a.12xlarge",
  G4DN_XLARGE = "g4dn.xlarge",
  G4DN_2XLARGE = "g4dn.2xlarge",
  G4DN_4XLARGE = "g4dn.4xlarge",
  G4DN_8XLARGE = "g4dn.8xlarge",
  G4DN_16XLARGE = "g4dn.16xlarge",
}

enum InstanceCategory {
  GENERAL = "General Purpose",
  COMPUTE = "Compute Optimized",
  MEMORY = "Memory Optimized",
  ACCELERATED = "Accelerated Computing",
  STORAGE = "Storage Optimized",
  HPC = "HPC Optimized",
}

export const DISPLAY_INSTANCE_TYPE: Record<
  InstanceType,
  {
    label: string;
    category: InstanceCategory;
  }
> = {
  [InstanceType.T3A_MEDIUM]: {
    label: "Medium",
    category: InstanceCategory.GENERAL,
  },
  [InstanceType.M6A_LARGE]: {
    label: "Large",
    category: InstanceCategory.GENERAL,
  },
  [InstanceType.M6A_XLARGE]: {
    label: "X-Large",
    category: InstanceCategory.GENERAL,
  },
  [InstanceType.M6A_2XLARGE]: {
    label: "2X-Large",
    category: InstanceCategory.GENERAL,
  },
  [InstanceType.M6A_4XLARGE]: {
    label: "4X-Large",
    category: InstanceCategory.GENERAL,
  },
  [InstanceType.M6A_8XLARGE]: {
    label: "8X-Large",
    category: InstanceCategory.GENERAL,
  },
  [InstanceType.M6A_12XLARGE]: {
    label: "12X-Large",
    category: InstanceCategory.GENERAL,
  },
  [InstanceType.G4DN_XLARGE]: {
    label: "GPU X-Large",
    category: InstanceCategory.ACCELERATED,
  },
  [InstanceType.G4DN_2XLARGE]: {
    label: "GPU 2X-Large",
    category: InstanceCategory.ACCELERATED,
  },
  [InstanceType.G4DN_4XLARGE]: {
    label: "GPU 4X-Large",
    category: InstanceCategory.ACCELERATED,
  },
  [InstanceType.G4DN_8XLARGE]: {
    label: "GPU 8X-Large",
    category: InstanceCategory.ACCELERATED,
  },
  [InstanceType.G4DN_16XLARGE]: {
    label: "GPU 16X-Large",
    category: InstanceCategory.ACCELERATED,
  },
};

export default InstanceType;
